import { STUDY_ID, TRIAGE_API_VERSION, TRIAGE_ENDPOINT } from '../constants';

import { RSAA } from 'redux-api-middleware';
import { getPreviewToken } from '../services';

console.log('HECKA HELLA');
console.log(TRIAGE_ENDPOINT);
const baseURL = `${TRIAGE_ENDPOINT}/api/${TRIAGE_API_VERSION}/studies/${STUDY_ID}/`;
console.log(baseURL);

const authHeader = limited_token => ({
  'Content-Type': 'application/json',
  'Preview-Token': getPreviewToken(),
  'Limited-Token': limited_token,
});

export const getMeta = () => ({
  [RSAA]: {
    endpoint: baseURL + `meta`,
    method: 'GET',
    headers: authHeader(),
    types: ['META/REQUEST', 'META/RECEIVE', 'META/FAILURE'],
  },
});

export const getNode = (payload, request) => {
  return {
    [RSAA]: {
      endpoint: baseURL + request,
      method: 'GET',
      headers: authHeader(),
      types: [
        'NODE/REQUEST',
        {
          type: 'NODE/RECEIVE',
          payload: (action, state, res) => res.json().then(newres => newres),
        },

        'NODE/FAILURE',
      ],
    },
  };
};

export const clearErrors = () => ({ type: 'ERRORS/CLEAR' });



// WEBPACK FOOTER //
// ./src/actions/meta_actions.js